import {
    ManufacturerProductPropertyDetail,
    ManufacturerProductSpecDocDetail,
    ManufacturerProductVideoDetail,
} from 'components/Models/product'

export const getDocDetail = (
    docs: Partial<ManufacturerProductSpecDocDetail>[] | undefined,
    docType: 'ShortForm' | 'FullLength'
): Partial<ManufacturerProductSpecDocDetail> | undefined =>
    docs?.filter((each) => each.docType === docType && !!each.path)?.[0]

export const getNormalizedProperties = (
    properties?: Partial<ManufacturerProductPropertyDetail>[]
) => {
    const propertiesObj: Record<
        string,
        Partial<ManufacturerProductPropertyDetail>[]
    > = {}
    properties?.map(
        ({
            propertyName = '',
            isPremiumPlus = false,
            options,
            optionGroups,
            propertyId,
        }) => {
            const propertyNameArr = propertyName.split('|')
            const mainPropertyNameWithDrawingDesignation = propertyNameArr
                .slice(0, propertyNameArr.length - 1)
                .join(' / ')
            const mainPropertyName = mainPropertyNameWithDrawingDesignation
                .split('<')[0]
                .trim()
            const prevValue = propertiesObj[mainPropertyName] ?? []

            //Don't include properties where all options are 'isOther'
            const allValidOptions = optionGroups
                ?.flatMap((grp) => grp.options)
                ?.filter((option) => !option?.isOther)

            ;((allValidOptions && allValidOptions.length > 0) ||
                !!isPremiumPlus) &&
                (propertiesObj[mainPropertyName] = [
                    ...prevValue,
                    {
                        isPremiumPlus,
                        subPropertyName:
                            propertyNameArr[propertyNameArr.length - 1],
                        options,
                        optionGroups: optionGroups ?? [],
                        propertyId,
                        originalPropertyName: mainPropertyNameWithDrawingDesignation,
                    },
                ] as Partial<ManufacturerProductPropertyDetail>[])
        }
    )

    return propertiesObj
}

export const getSelectedProperties = (
    past?: Partial<ManufacturerProductPropertyDetail>[]
) => {
    const properties = getNormalizedProperties(past)
    const selectedDataObj: Record<string, Record<string, string[]>> = {}
    const propObj: Record<
        string,
        Partial<ManufacturerProductPropertyDetail>[]
    > = {
        ...properties,
    }
    Object.keys(propObj).forEach((propertyName) => {
        const tempObj: Record<string, string[]> = {}
        propObj[propertyName]?.map(
            (subProp) =>
                (tempObj[subProp.subPropertyName!] = subProp.optionGroups
                    ?.flatMap((grp) =>
                        grp.options?.map(
                            (option) =>
                                option.isSupported ? option.optionId : null //filters data
                        )
                    )
                    ?.filter((optionId) => !!optionId) as string[])
        )
        selectedDataObj[propertyName] = tempObj
    })

    return selectedDataObj
}

export const convertVideoDetailToLinks = (
    video: Partial<ManufacturerProductVideoDetail>
) => {
    if (video.fromSource === 'Vimeo') {
        return `https://vimeo.com/${video.videoId?.replace('?h=', '/')}`
    }

    return `https://youtube.com/watch?v=${video.videoId}`
}
